import { Divider, Stack } from "@mui/material";
import React from "react";

import { Answer, Section as TSection } from "../../../globals/types";
import CodeOfConductQuestion from "../../CodeOfConductQuestion";
import Question from "../../Question";

type Props = {
    section: TSection;
    preview?: boolean;
    answers: Record<string, Answer>;
    disabled: boolean;
    setSubmitBlocked: React.Dispatch<React.SetStateAction<boolean>>;
};

const Section: React.FC<Props> = ({ section, preview, answers, disabled, setSubmitBlocked }) => {
    return (
        <Stack divider={<Divider />}>
            {section.questions.map((question, index) => {
                const inner =
                    question.referenceId === "code-of-conduct" ? (
                        <CodeOfConductQuestion
                            number={index + 1}
                            question={question}
                            preview={preview}
                            answer={answers[question.id]}
                            disabled={disabled}
                            setSubmitBlocked={setSubmitBlocked}
                        />
                    ) : (
                        <Question
                            question={question}
                            number={index + 1}
                            preview={preview}
                            answer={answers[question.id]}
                            disabled={disabled}
                            setSubmitBlocked={setSubmitBlocked}
                        />
                    );
                return (
                    <Stack key={question.id} py={3}>
                        {inner}
                    </Stack>
                );
            })}
        </Stack>
    );
};

export default Section;
